import { render } from "./sb-spinner.vue?vue&type=template&id=4d4b4f56&ts=true"
import script from "./sb-spinner.ts?vue&type=script&lang=ts"
export * from "./sb-spinner.ts?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./sb-spinner.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/luca/comperioprojects/selfbox_frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__